import styled from "styled-components";

export const ContentCircles = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  height: 100%;
  flex-wrap: wrap;
  .palette-icon {
    width: auto;
    height: 2em;
    cursor: pointer;
    color: ${({ theme }) => theme.neutral.white};
    border-radius: 99px;
    background: linear-gradient(to bottom, ${({ theme }) => theme.primary.redLight}, ${({ theme }) => theme.primary.yellow});
    &:hover {
      opacity: 0.8;
    }
  }
  .app-palette {
    max-width: 456px;
    width: 100%;
    padding: 20px;
  }
`;

export const CircleText = styled.div`
  flex: 0 0 14.5%;
  width: auto;
  height: 2em;
  box-sizing: border-box;
  border-radius: 99px;
  cursor: pointer;
  font-size: 26px;
  font-weight: 500;
  margin: 0.2em;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: ${({ theme }) => theme.neutral.white};
  border: ${({ colorSelected, bgColor, theme }) => colorSelected === bgColor ? `4px solid ${theme.primary.green}` : ""};
  background: ${({ bgColor }) => bgColor};
  &:hover {
    opacity: 0.8;
    border: 4px solid ${({ theme }) => theme.primary.green};
  }
`;
export const ContainerButtons = styled.div`
  display: flex;
  flex-direction: row-reverse;
  align-items: flex-end;
  position: relative;
`;

export const CancelButton = styled.button`
  background: ${({ theme }) => theme.neutral.white};
  color: ${({ theme }) => theme.primary.purple};
  font-size: 14px;
  font-weight: 500;
  border: 1px solid ${({ theme }) => theme.primary.purple};
  box-shadow: 0px 4px 18px ${({ theme }) => theme.shadows.medium};
  border-radius: 5px;
  width: 30%;
  height: 43.21px;
  margin: 0.2em;
  &:hover {
    box-shadow: 0px 4px 20px 0px ${({ theme }) => theme.primary.purpleLightOpacity};
    transform: translateY(-1px);
    cursor: pointer;
  }
`;

export const SaveButton = styled.button`
  background: ${({ theme }) => theme.primary.purple};
  color: ${({ theme }) => theme.neutral.white};
  font-size: 14px;
  font-weight: 500;
  border: none;
  box-shadow: 0px 4px 18px ${({ theme }) => theme.shadows.medium};
  border-radius: 5px;
  width: 30%;
  height: 43.21px;
  margin: 0.2em;
  &:hover {
    box-shadow: 0px 4px 20px 0px ${({ theme }) => theme.primary.purpleLightOpacity};
    transform: translateY(-1px);
    cursor: pointer;
  }
`;